export class FixedValue {
    id: string;
    name: string;
    value: number;
    scale: string;
    color: string;
    pane: number;
}